<template>
<div class="carousel-selector" ref="blocksContainer">
  <draggable tag="ul" :list="attachments" :animation="400" :move="checkMove" class="blocks is-flex" ref="blocks" @scroll="scrollBlocks" v-bind="{ disabled : isMobile }">
    <li v-for="(attachment, offset) in maxAttachments" :key="offset" :class="{ 'is-active': selected === offset }" :data-attachment="attachment" :data-offset="offset">
      <div v-if="!attachUrl(offset) && !isFile(offset) && !isVideo(offset) && !isPoll(offset) && !isImage(offset) && !isEmbeddedVideo(offset)" class="add-block cursor-pointer is-flex" @click="clickBlock(offset)"><i class="fal fa-plus"></i></div>
      <div v-if="attachUrl(offset) && isLink(offset)" class="preview" @click="clickSelection(offset)"
          :class="{'link-border': isLink(offset), 'invert-link-image': !hasLinkIcon(offset), 'non-move': attachments[offset].locked}"
          :style="{'background-image': 'url(' + attachUrl(offset) + ')'}">
          <span class="link" v-if="attachments[offset].type === 'link' || attachments[offset].type === 'video'" ><i class="fal fa-link"></i></span>
      </div>
      <div v-if="attachUrl(offset) && isIframe(offset)" class="preview" @click="clickSelection(offset)"
          :class="{'link-border': isIframe(offset), 'invert-link-image': !hasLinkIcon(offset), 'non-move': attachments[offset].locked}"
          :style="{'background-image': 'url(' + attachUrl(offset) + ')'}">
          <span class="link" v-if="attachments[offset].type === 'iframe'" ><i class="fal fa-browser"></i></span>
      </div>
      <div v-if="!attachUrl(offset) && isFile(offset) && !isPoll(offset)" class="icon is-flex" @click="clickSelection(offset)">
        <div><span :style="fileTypeColour(offset)"><i class="fa-2x" :class="fileTypeClass(offset)"></i></span></div>
      </div>
      <div v-if="isPoll(offset)" class="icon is-flex" @click="clickSelection(offset)">
        <div><i class="fa fa-list-alt" ></i></div>
      </div>
      <div v-if="isVideo(offset)" class="icon is-flex" @click="clickSelection(offset)">
        <div v-if="isVideoProcessing(offset)" class="preview is-flex invert-link-image is-justify-content-center is-vcentered is-align-items-center">
          <span class="video-processing">
              <i class="fal fa-circle-notch fa-spin"></i>
            </span>
        </div>
        <div v-else class="preview invert-link-image" :style="{ backgroundImage: 'url(' + attachUrl(offset) + ')' }"></div>
      </div>
      <div v-if="isImage(offset)" class="icon is-flex" @click="clickSelection(offset)">
        <div class="preview invert-link-image" :style="{ backgroundImage: 'url(' + attachUrl(offset) + ')' }"></div>
      </div>
      <div v-if="isEmbeddedVideo(offset)" class="icon is-flex" @click="clickSelection(offset)">
        <div class="preview invert-link-image" :style="{ backgroundImage: 'url(' + attachUrl(offset) + ')' }"></div>
      </div>
    </li>
  </draggable>
  <div class="button-container is-hidden-mobile cursor-pointer">
    <div v-if="canScrollLeft" class="start is-flex" @click="clickLeft"><i class="fal fa-chevron-left"></i></div>
    <div v-if="canScrollRight" class="end is-flex" @click="clickRight"><i class="fal fa-chevron-right"></i></div>
  </div>
</div>
</template>

<script>

import fileType from '@/libs/file-type'
import Draggable from 'vuedraggable'
import breakpoints from '@/libs/breakpoints'

const scrollAmount = 65

export default {
  components: {
    Draggable
  },
  props: ['attachments', 'carouselPosition', 'post'],
  data: function () {
    return {
      scrollLeft: 0,
      selected: this.carouselPosition || 0,
      dragging: { to: null, from: null },
      isMounted: false
    }
  },
  watch: {
    carouselPosition: function () {
      this.selected = this.carouselPosition
    }
  },
  mounted: function () {
    this.isMounted = true
  },
  computed: {
    canScrollLeft: function () {
      return this.scrollLeft > 0
    },
    canScrollRight: function () {
      if (this.isMounted) {
        const blocksWidth = this.$refs.blocks.$el.scrollWidth
        const blocksContainerWidth = this.$refs.blocksContainer.clientWidth
        return this.scrollLeft + blocksContainerWidth < blocksWidth
      }
      return false
    },
    maxAttachments: function () {
      return this.post?.maxAttachments ? this.post.maxAttachments : 12
    },
    isLocked: function () {
      const attachment = this.attachments[this.carouselPosition]
      if (!attachment) {
        return false
      }
      return attachment.locked
    },
    isDraggable: function () {
      return !this.isLocked
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  methods: {
    checkMove: function (evt) {
      return (!!evt.draggedContext.element)
    },
    attachment: function (i) {
      return this.attachments[i]
    },
    isImage: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'image'
      }
    },
    isCheckType: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type
      }
    },
    clickBlock: function (i) {
      this.selected = i
      this.$emit('choosePost')
    },
    clickSelection: function (i) {
      this.selected = i
      this.$emit('clickSelection', i)
    },
    clickLeft: function () {
      if (!this.$refs.blocks.$el.scrollLeft) {
        this.$refs.blocks.$el.scrollLeft = 0
      }
      this.$refs.blocks.$el.scrollLeft -= scrollAmount
      this.scrollLeft = this.$refs.blocks.$el.scrollLeft
    },
    clickRight: function () {
      if (!this.$refs.blocks.$el.scrollRight) {
        this.$refs.blocks.$el.scrollRight = 0
      }
      this.$refs.blocks.$el.scrollLeft += scrollAmount
      this.scrollLeft = this.$refs.blocks.$el.scrollLeft
    },
    scrollBlocks: function () {
      this.scrollLeft = this.$refs.blocks.$el.scrollLeft
    },
    attachUrl: function (n) {
      if (this.attachments[n]) {
        if (this.attachments[n].type === 'image' || this.attachments[n].type === 'poll') {
          return this.attachments[n].url
        } else if (this.attachments[n].type === 'video') {
          return this.attachments[n].url + `?t=${new Date().getTime()}`
        } else if (this.attachments[n].type === 'whiteboard') {
          return this.attachments[n].url
        } else if (this.attachments[n].type === 'iframe') {
          return this.attachments[n].metadata.ogImage || this.attachments[n].metadata.screenshot || this.attachments[n].metadata.favicon || '/static/icons/link-icon.svg'
        } else if (this.attachments[n].type === 'link' || this.attachments[n].type === 'embeddedVideo') {
          return this.attachments[n].metadata.ogImage || this.attachments[n].metadata.screenshot || this.attachments[n].metadata.favicon || '/static/icons/link-icon.svg'
        }
      }
    },
    hasLinkIcon: function (n) {
      return this.isLink(n) && (this.attachments[n].metadata.ogImage || this.attachments[n].metadata.screenshot || this.attachments[n].metadata.favicon)
    },
    isFile: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'file'
      }
    },
    isVideo: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'video'
      }
    },
    isVideoProcessing: function (n) {
      if (this.attachments[n] && this.attachments[n].type === 'video') {
        if (this.attachments[n].metadata.transactionId) {
          return this.$store.getters.isAttachmentVideoProcessing(this.attachments[n].metadata.transactionId)
        }
      }

      return false
    },
    isLink: function (n) {
      return this.attachments[n].type === 'link' || this.attachments[n].type === 'whiteboard'
    },
    isIframe: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'iframe'
      }
    },
    isPoll: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'poll'
      }
    },
    isEmbeddedVideo: function (n) {
      if (this.attachments[n]) {
        return this.attachments[n].type === 'embeddedVideo'
      }
    },
    fileTypeAtPosition: function (n) {
      let metadata = { name: '', type: '' }
      if (this.attachments[n]) {
        metadata = this.attachments[n].metadata
      }

      return fileType.iconForNameOrType(metadata.name, metadata.type)
    },
    fileTypeClass: function (n) {
      return this.fileTypeAtPosition(n).class
    },
    fileTypeColour: function (n) {
      const ft = this.fileTypeAtPosition(n)

      const style = {}

      if (ft.colour) {
        style.color = ft.colour
      }

      return style
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.blocks {
  cursor: move;
  padding: 0.5rem 0;
  min-width: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  flex-wrap: nowrap;
  @include mobile {
    overflow-x: scroll;
  }
  .non-move {
    cursor: not-allowed;
  }

  .add-block {
    background-color: $grey-lightest;
    min-width: 5rem;
    width: 5rem;
    padding:0.8rem 0;
    margin: 0 0.1rem;
    color: $grey-dark;
    flex: 0 0 auto;
    height: 3rem;
    justify-content: center;
    align-items: center;
  }
  .preview {
    position: relative;
    max-height: 3rem;
    height: 3rem;
    width: 5rem;
    max-width: 5rem;
    overflow-y: hidden;
    padding: 0;
    margin: 0 0.1rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: 2px solid #b7b7b7;
    .link {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0.1rem;
      i {
        background: $primary-gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  .link-border {
    border: 2px solid #b7b7b7;
  }
  .invert-link-image {
    -webkit-filter: invert(0.20);
    filter: invert(0.20);
  }
}

  .icon {
    height: 3rem;
    min-width: 5rem;
    border: 2px solid #b7b7b7;
    border-radius: 5px;
    position: relative;
    justify-content: center;
    align-items: center;
  }

.preview, .add-block, .icon{
  border: none;
}

.is-active {
  .preview, .add-block, .icon{
    margin: 0 0.1rem;
    border: 2px solid $grey-light;
    height: 3rem;
    max-height: 3rem;
  }
}
.carousel-selector {
  position: relative;
}
.button-container {
  position: absolute;
  width: 100%;
  top: 0.5rem;
  .start, .end {
    height: 3rem;
    position: absolute;
    background: $grey-medium;
    padding: 0.6rem 0.4rem;
    -webkit-box-shadow: 2px 2px 5px 0px rgba(136,136,136,0.41);
    -moz-box-shadow: 2px 2px 5px 0px rgba(136,136,136,0.41);
    box-shadow: 2px 2px 5px 0px rgba(136,136,136,0.41);
    justify-content: center;
    align-items: center;
  }
  .start {
    left: 0;
  }
  .end {
    right: 0;
  }
  i {
    color: #fff;
  }
}
</style>
